<template>
  <div class="custom-checkbox">
    <label>
      <input
        type="checkbox"
        @change="$emit('input', $event.target.checked)"
      />
      <span></span>
    </label>
    <label v-if="labelText" class="custom-checkbox__label">
      {{ labelText }}
    </label>
  </div>
</template>

<script>
export default {
  emits: ['input'],
  props: {
    labelText: String,
  },
};
</script>

<style scoped>
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  --checkbox-color: #428bca;
  --checkmark-color: #000;
}
.custom-checkbox__label {
  padding-left: 0.5em;
  max-width: 200px;
}
.custom-checkbox input {
  display: none;
}
.custom-checkbox input:checked ~ span {
  color: #fff;
  background: var(--checkbox-color);
}
.custom-checkbox input:checked ~ span:after {
  visibility: visible;
}
.custom-checkbox label {
  position: relative;
}
.custom-checkbox span {
  width: 34px;
  height: 34px;
  border: 1px solid var(--checkbox-color);
  display: inline-block;
  border-radius: 50%;
  transition: all linear 0.15s;
  position: relative;
}
.custom-checkbox span:after {
  content: "";
  margin: 0 auto;
  position: absolute;
  right: 0;
  left: 0;
  top: 30%;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  height: 11px;
  width: 4px;
  transform: rotate(45deg);
  visibility: hidden;
}
.custom-checkbox span:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Checkbox.vue